import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

const apiService = {
  // 获取所有账户列表
  getAccountsList() {
    return apiClient.get('/api/accounts')
  },
  // 获取指定账户的详细信息
  getAccountDetail(accountId) {
    return apiClient.get(`/api/accounts/${accountId}`)
  },
  // 获取指定任务的详细信息，包括每日收益数据
  getTaskDetail(accountId, taskId) {
    return apiClient.get(`/api/accounts/${accountId}/tasks/${taskId}/details`)
  },
  // 获取指定账户的所有任务列表
  getAccountTasksList(accountId) {
    return apiClient.get(`/api/accounts/${accountId}/tasks`)
  },



  // 创建新任务
  createTask(accountId, taskData) {
    return apiClient.post(`/api/accounts/${accountId}/tasks`, taskData)
  },
  // 更新任务状态
  updateTaskStatus(taskId, status) {
    return apiClient.patch(`/api/tasks/${taskId}`, { status })
  },
  // 添加任务详情
  addTaskDetail(taskId, detailData) {
    return apiClient.post(`/api/tasks/${taskId}/details`, detailData)
  },
  // 获取账户最新总收益
  getAccountLatestTotal(accountId) {
    return apiClient.get(`/api/accounts/${accountId}/latest-total`)
  }
}

export default apiService;
